import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEllipseHorizontal = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EllipseHorizontal</title>
    <circle cx={8.668} cy={16.001} r={2} fill="currentColor" />
    <circle cx={16.001} cy={16.001} r={2} fill="currentColor" />
    <circle cx={23.337} cy={16.002} r={2} fill="currentColor" />
  </svg>
);
export default SvgIcoEllipseHorizontal;
